import { request, RespError, handleFormatRes } from '../../utils';
import { SET_USER_BITMAP } from '../../config/url';
import { formatEkycStatus } from './format-ekyc-status';
export * from './types';
// 需要转成 int 型的 key 数组
const needParseIntKey = [];
// 需要转成 date 型的 key 数组
const needParseDateKey = ['sysTime'];
/**
 * 查询用户属性，如ekyc
 *
 * ekyc查询接口： ia_ekyc_query_user_inner_c 内部业务查询接口
 *
 * 接口地址：`/app/promotion/prom_set_user_bitmap.cgi`
 *
 * @param userAttr 枚举，如：ekyc – 查询用户EKYC状态
 * @returns ekyc
 */
export async function setUserBitmap({ userAttr, userAttrList }) {
    var _a;
    try {
        // 参数格式化
        let params = {
            t: new Date().getTime(),
        };
        if (userAttr) {
            params = Object.assign(Object.assign({}, params), { user_attr: userAttr });
        }
        else if (userAttrList) {
            params = Object.assign(Object.assign({}, params), { 
                // 后端支持控制是否缓存，但暂时没有场景需要去除缓存，先不暴露出来
                user_attr_list: JSON.stringify(userAttrList.map(key => ({ attr_name: key, cache: '1' }))) });
        }
        // 接口请求
        const result = await request.get(SET_USER_BITMAP, { params });
        if (result) {
            // 正常的返回
            if ((result === null || result === void 0 ? void 0 : result.retcode) === '0') {
                let res = handleFormatRes({ result, needParseIntKey, needParseDateKey });
                // 处理用户属性 - ekyc
                res = Object.assign(Object.assign({}, res), { ekyc: formatEkycStatus((_a = res.ekyc) === null || _a === void 0 ? void 0 : _a[0]), isBindCard: typeof res.cardBind === 'undefined' ? undefined : !!+res.cardBind });
                delete res.cardBind;
                return res;
            }
            // 状态码错误的返回
            throw new RespError(result.retcode, result.retmsg, result);
        }
        throw result;
    }
    catch (error) {
        throw error;
    }
}
